import React from 'react';
import { useTranslation } from 'react-i18next';

import { Footer, Header, SeoHelmet } from 'components/index';

import AnalysisForm from './components/AnalysisForm';

import style from './Analysis.module.scss';

const Analysis = () => {
  const { t } = useTranslation('page');
  return (
    <>
      <SeoHelmet
        title={t('analysis.title')}
        description={t('analysis.description')}
      />
      <div className={style.container}>
        <Header />
        <AnalysisForm />
        <Footer />
      </div>
    </>
  );
};

export default Analysis;
